module.exports = __webpack_public_path__ + "static/recruit_home__targetting-persons-brazil-06eaa042fe34824dae1189547d82eb46.jpg";